import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "d-block invalid-feedback"
}
const _hoisted_11 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[8] || (_cache[8] = [
        _createTextVNode("Create Question")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modal = !_ctx.modal)),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            class: "btn btn-primary"
          }, "Save")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("label", null, "Type", -1)),
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(["custom-select", {'is-invalid':!_ctx.validation.selectedType}]),
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeType && _ctx.changeType(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedType) = $event)),
            required: ""
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("option", {
              selected: "",
              disabled: "",
              hidden: "",
              value: undefined
            }, "-- Select a Question Type --", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.QuestionType).filter(key => isNaN(_ctx.QuestionType[key])), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item,
                key: index
              }, _toDisplayString(_ctx.Question.parseType(item)), 9, _hoisted_2))
            }), 128))
          ], 34), [
            [_vModelSelect, _ctx.selectedType]
          ]),
          (!_ctx.validation.selectedType)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, "A question type must be selected"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("label", null, "Question", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass([{'is-invalid':!_ctx.validation.questionText}, "form-control"]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.questionText) = $event)),
            required: "",
            cols: "3"
          }, null, 2), [
            [_vModelText, _ctx.questionText]
          ]),
          (!_ctx.validation.questionText)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, "Question text is required"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.selectedType !== undefined && _ctx.selectedType !== _ctx.QuestionType.LONGFILL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Answers:", -1)),
              _createVNode(_component_VueDraggableNext, {
                class: "dragArea list-group w-full",
                modelValue: _ctx.answers,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.answers) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-flex justify-content-start align-items-center mb-2",
                      key: index
                    }, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "text-primary cursor-pointer fa fa-bars" }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.answers[index]) = $event),
                        class: "form-control mx-2"
                      }, null, 8, _hoisted_7), [
                        [_vModelText, _ctx.answers[index]]
                      ]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeAnswer(parseInt(index))),
                        class: "btn btn-primary float-end"
                      }, _cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fa fa-minus" }, null, -1)
                      ]), 8, _hoisted_8)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addAnswer && _ctx.addAnswer(...args))),
                disabled: _ctx.answers.length >= _ctx.maxAnswers,
                class: "btn btn-primary float-end"
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "fa fa-plus" }, null, -1)
              ]), 8, _hoisted_9),
              (!_ctx.validation.answers)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.validation.answersText), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}